import detailDefault from '../../detailDefault';
export default class detailaon_license_model_countries extends detailDefault {
    load(sAction, data) {
        // jmeno relate pole Model -> Select Model
        sAction.dataSet(data.prefix + '/fields/aon_list_of_models_acm_license_model_1_name/def/vname', 'LBL_SELECT_MODEL');

        if (!sAction.dataGet(data.prefix + '/fields/id/value')) {
            setTimeout(() => {
                data.value = {};
                data.value.id = sAction.dataGet(data.prefix + '/fields/aon_list_of_models_aon_license_model_countries_1_name/def/id_value');
                data.value.name = sAction.dataGet(data.prefix + '/fields/aon_list_of_models_aon_license_model_countries_1_name/value');
                this.loadModelData(sAction, data);
            }, 500);
        }
    }

    update(sAction, data) {
        let fieldData;
        let sendData;

        switch (data.field) {
            case 'acm_licensd5e5e_model_ida':
                if (!data.value.id) {
                    return;
                }

                sendData = {
                    module: 'acm_license_model',
                    id: data.value.id,
                    fields: [
                        'aon_list_of_models_acm_license_model_1aon_list_of_models_ida',
                        'aon_list_of_models_acm_license_model_1_name',
                        'accounts_acm_license_model_1accounts_ida',
                        'accounts_acm_license_model_1_name',
                    ],
                    action: 'getBeanInfo',
                };

                sAction.load();
                sAction.rest.fetchData('customAction', 'POST', sendData).then((returnData) => {
                    // console.log(returnData)

                    sAction.dsClear();

                    fieldData = {
                        way: data.prefix + '/fields/aon_list_of_models_aon_license_model_countries_1_name',
                        name: 'aon_list_o2a4f_models_ida',
                        fieldName: 'aon_list_of_models_aon_license_model_countries_1_name',
                        type: 'relate',
                        value: {
                            id: returnData.aon_list_of_models_acm_license_model_1aon_list_of_models_ida,
                            name: returnData.aon_list_of_models_acm_license_model_1_name,
                        },
                    };
                    sAction.saveField(fieldData, true);

                    fieldData = {
                        way: data.prefix + '/fields/accounts_aon_license_model_countries_1_name',
                        name: 'accounts_aon_license_model_countries_1accounts_ida',
                        fieldName: 'accounts_aon_license_model_countries_1_name',
                        type: 'relate',
                        value: {
                            id: returnData.accounts_acm_license_model_1accounts_ida,
                            name: returnData.accounts_acm_license_model_1_name,
                        },
                    };
                    sAction.saveField(fieldData, true);

                    sAction.unLoad();
                }).catch((data) => {
                    console.error(data);
                    sAction.unLoad();
                });
                break;
            case 'aon_list_o2a4f_models_ida':
                this.loadModelData(sAction, data);

                break;
        }
    }

    loadModelData(sAction, data) {
        if (!data.value.id) {
            return;
        }
        sAction.dsClear();
        sAction.dsAdd('set', data.prefix + '/fields/name/value', data.value.name);
        sAction.dsAdd('set', data.prefix + '/changes/fields/name', data.value.name);
        sAction.dsProcess();

        const fields = {
            model_type: 'model_type',
            subperil: 'subperil',
            risk_data: 'risk_data',
            loss_table: 'loss_table',
            original_model_release: 'original_model_release',
            date_of_last_update: 'date_of_last_update',
            date_of_next_update: 'date_of_next_update',
            contact_person_business_development_id: 'contact_person_business_development_id',
            contact_person_business_development: 'contact_person_business_development',
            description_portal: 'description_portal',
            description: 'description_model',
            assigned_user_id: 'contact_person_rad_id',
            assigned_user_name: 'contact_person_rad',
            current_model_version: 'current_model_version',
            aer: 'aer',
            hazard_data: 'hazard_data',
            peril: 'peril',
            region: 'region',
            name: 'name_model',
            model_id: 'model_id',
            scenario: 'scenario',
            probabilistic: 'probabilistic',
        };

        const sendData = {
            module: 'aon_list_of_models',
            id: data.value.id,
            fields: Object.keys(fields),
            action: 'getBeanInfo',
        };

        sAction.load();
        sAction.rest.fetchData('customAction', 'POST', sendData).then((returnData) => {
            // console.log(returnData)

            sAction.dsClear();
            returnData.forEachObject((v, k) => {
                sAction.dsAdd('set', data.prefix + '/fields/' + fields[k] + '/value', v);
                sAction.dsAdd('set', data.prefix + '/changes/fields/' + fields[k] + '', v);
            });
            sAction.dsProcess();

            sAction.unLoad();
        }).catch((data) => {
            console.error(data);
            sAction.unLoad();
        });
    }
}
